import clsx from 'clsx';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useAxios from '../../axios/useAxios';
import { getMidiDealProducts, logMidiDealEvent } from '../../actions/midiDealActions';
import iconDrink from '../../styles/img/midiDeal/iconDrink.svg';
import iconFood from '../../styles/img/midiDeal/iconFood.svg';
import iconSnack from '../../styles/img/midiDeal/iconSnack.svg';
import pikko from '../../styles/img/midiDeal/pikko.svg';
import { MidiDealDrawer } from './MidiDealDrawer';
export const MidiDealProgressBar = ({
    selectedMain,
    selectedSnack,
    selectedDrink,
    price = '4,50€',
    savings = '0,00€',
}) => {
    const steps = [
        { id: 'main', icon: iconFood, selected: selectedMain },
        { id: 'snack', icon: iconSnack, selected: selectedSnack },
        { id: 'drink', icon: iconDrink, selected: selectedDrink },
    ].sort((a, b) => Number(b.selected) - Number(a.selected));

    const completedSteps = steps.filter((s) => s.selected).length;
    const progress = (completedSteps / steps.length) * 100;
    const isComplete = completedSteps === 3;

    const { products = [], loading, dealActive } = useSelector((state) => state.midiDeal || {});
    const { store } = useSelector((state) => state.store);
    const { cartItems } = useSelector((state) => state.cart);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const dispatch = useDispatch();
    const axiosInstance = useAxios();

    useEffect(() => {
        if (!products.length && store?.id) {
            dispatch(getMidiDealProducts(store.id, axiosInstance));
        }
    }, [dispatch, store?.id, axiosInstance, products.length]);

    useEffect(() => {
        if (isComplete) {
            dispatch(logMidiDealEvent(axiosInstance, {
                event: 'midideal.ui.savings_shown',
                orderId: cartItems?._id,
                storeId: store?.id,
                midiDealData: {
                    dealPrice: store?.midiDeal?.dealPrice,
                    timeSlot: store?.midiDeal?.timeSlot,
                    dealActive,
                    savings,
                    currentStep: completedSteps,
                    totalStep: 3,
                },
            }));
        }
    }, [isComplete]);

    const handleOpenDrawer = () => {
        setIsDrawerOpen(true);
    };

    return (
        <>
            <div
                onClick={handleOpenDrawer}
                className={clsx(
                    "fixed max-w-[328px] w-full top-16 border-t-0 rounded-t-none left-1/2 -translate-x-1/2 backdrop-blur-md rounded-b-3xl p-4 z-[1000] overflow-hidden transition-all duration-500 cursor-pointer",
                    {
                        "bg-[#3a3a3a48] border border-[#fbf7ed50]": !isComplete,
                        "border-none shadow-[0_4px_15px_rgba(255,222,89,0.3)]": isComplete
                    }
                )}
                style={{
                    background: isComplete ? `linear-gradient(0deg, rgba(162, 162, 162, 0.09), rgba(162, 162, 162, 0.09)),
                    linear-gradient(180deg, #FFDE59 63.5%, #F19F10 100%),
                    linear-gradient(0deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0))` : undefined
                }}
            >
                {isComplete ? (
                    <div className="flex items-center justify-between relative h-12 w-full" >
                        <img
                            src={pikko}
                            alt="Pikko"
                            className="absolute bottom-[-24px] left-[-10px] w-16 transition-transform duration-500 ease-out transform translate-y-0 animate-slide-up"
                            style={{
                                animation: 'slideUpMidiDealProgressBar 0.5s ease-out forwards',
                            }}
                        />
                        <div className="flex-1 flex justify-center items-center gap-2 ml-8">
                            <span className="geomanistBold text-[#3a3a3a] text-[18px]">
                                Économies:
                            </span>
                            <span className="geomanistBold text-[#3a3a3a] text-[22px]">
                                {savings}
                            </span>
                        </div>
                    </div>
                ) : (
                    <div className="flex items-center justify-between gap-4">
                        {/* Icons */}
                        <div className="flex items-center">
                            {steps.map((step, index) => (
                                <div
                                    key={step.id}
                                    style={{
                                        marginLeft: index > 0 ? -8 : 0,
                                        zIndex: 30 - index * 10,
                                    }}
                                    className={clsx(
                                        'w-12 h-12 rounded-full flex items-center justify-center border bg-[#3a3a3a]',
                                        {
                                            'bg-gradient-to-br border-2 border-[#ad8d0e63] from-[#f8df7a] to-[#f4ba56]':
                                                step.selected,
                                            'border-2 border-dashed border-gray-300 bg-transparent':
                                                !step.selected,
                                        },
                                    )}
                                >
                                    <img
                                        src={step.icon}
                                        alt={step.id}
                                        className="w-5 h-5"
                                        style={{
                                            filter: step.selected ? 'none' : 'brightness(0) invert(1) ',
                                        }}
                                    />
                                </div>
                            ))}
                        </div>

                        <div className="flex-1 h-[9px] mx-4 bg-[#E4E4E475] rounded-full overflow-hidden">
                            <div
                                className="h-full bg-gradient-to-r from-[#FFDE59] to-[#F19F10] rounded-full transition-all duration-300"
                                style={{ width: `${progress}%` }}
                            />
                        </div>

                        <span
                            className="geomanistBold text-white text-[20px]"
                            style={{ letterSpacing: '1px' }}
                        >
                            {price}
                        </span>
                    </div>
                )}
            </div >
            <MidiDealDrawer
                isOpen={isDrawerOpen}
                onClose={() => setIsDrawerOpen(false)}
                products={products}
                loading={loading}
            />
        </>
    );
};
